import React, { FC } from 'react';
import { TypeImage } from '@/core/generated-types';
import Image from 'next/image';

interface ImageProps {
  imageData: TypeImage;
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
  loading?: 'lazy' | 'eager';
}

const _formatImageUrl = (url: string | undefined) => {
  if (!url) {
    return 'https://placehold.co/600x400/png';
  }

  if (url.startsWith('http') || url.startsWith('https')) {
    return url;
  }
  return `https:${url}`;
};

const LuvImage: FC<ImageProps> = ({
  imageData,
  className,
  width,
  height,
  loading = 'lazy',
}) => {
  const defaultWidth =
    imageData?.fields?.Image?.fields?.file?.details?.image?.width ?? 50;
  const defaultHeight =
    imageData?.fields?.Image?.fields?.file?.details?.image?.height ?? 50;

  return (
    imageData && (
      <Image
        alt={imageData?.fields?.altText || ''}
        src={_formatImageUrl(imageData.fields?.Image?.fields?.file?.url)}
        className={className}
        width={width || defaultWidth}
        height={height || defaultHeight}
        loading={loading}
      />
    )
  );
};

export default React.memo(LuvImage);
